"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var distinguishedFolderId_1 = require("owa-service/lib/factory/distinguishedFolderId");
var findPeopleJsonRequest_1 = require("owa-service/lib/factory/findPeopleJsonRequest");
var findPeopleRequest_1 = require("owa-service/lib/factory/findPeopleRequest");
var indexedPageView_1 = require("owa-service/lib/factory/indexedPageView");
var personaResponseShape_1 = require("owa-service/lib/factory/personaResponseShape");
var targetFolderId_1 = require("owa-service/lib/factory/targetFolderId");
var findPeopleOperation_1 = require("owa-service/lib/operation/findPeopleOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
var contextProperty_1 = require("owa-service/lib/factory/contextProperty");
var defaultPageView = {
    BasePoint: 'Beginning',
    Offset: 0,
    MaxEntriesReturned: 10,
};
var defaultShape = {
    BaseShape: 'Default',
};
function configureContext() {
    return [contextProperty_1.default({ Key: 'AppName', Value: 'OWA' })];
}
// Setting SearchPeopleSuggestionIndex to true will resolve the displayName correctly for non-contacts
function createFindPeopleRequest(queryString) {
    return findPeopleRequest_1.default({
        IndexedPageItemView: indexedPageView_1.default(defaultPageView),
        PersonaShape: personaResponseShape_1.default(defaultShape),
        QuerySources: ['Mailbox', 'Directory'],
        QueryString: queryString,
        SearchPeopleSuggestionIndex: true,
        ShouldResolveOneOffEmailAddress: true,
        Context: configureContext(),
    });
}
// Setting SearchPeopleSuggestionIndex to false will return also contacts
// Contacts will be searched in the root folder 'MyContacts'
function createFindContactsRequest(queryString) {
    return findPeopleRequest_1.default({
        IndexedPageItemView: indexedPageView_1.default(defaultPageView),
        PersonaShape: personaResponseShape_1.default(defaultShape),
        QuerySources: ['Mailbox'],
        QueryString: queryString,
        ParentFolderId: targetFolderId_1.default({
            BaseFolderId: distinguishedFolderId_1.default({
                Id: 'mycontacts',
            }),
        }),
        Context: configureContext(),
    });
}
function processResponseMessage(responseMessage, isContact) {
    if (responseMessage.ResponseClass == 'Success') {
        return { personas: responseMessage.ResultSet, requestId: responseMessage.TransactionId };
    }
    throw new Error("FindPeople failed (" + responseMessage.ResponseCode + " " + responseMessage.MessageText + " " + isContact + ")");
}
function findPeopleByEmail(queryString) {
    return findPeopleOperation_1.default(findPeopleJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: createFindPeopleRequest(queryString),
    })).then(function (response) {
        return processResponseMessage(response.Body, false);
    });
}
exports.findPeopleByEmail = findPeopleByEmail;
function findContactsByEmail(queryString) {
    return findPeopleOperation_1.default(findPeopleJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: createFindContactsRequest(queryString),
    })).then(function (response) {
        return processResponseMessage(response.Body, true);
    });
}
exports.findContactsByEmail = findContactsByEmail;
//# sourceMappingURL=findPeopleByEmail.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/services/people/findPeopleByEmail.js
// module id = 3334
// module chunks = 14 68